/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsModeratorControllerFindRejectionReasonsQueryResponse,
  TelegramProductsModeratorControllerFindRejectionReasons401,
} from '../../types/TelegramProductsModeratorControllerFindRejectionReasons.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramProductsModeratorFindRejectionReasons } from '../../methods/telegramProductsModeratorFindRejectionReasons.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramProductsModeratorFindRejectionReasonsQueryKey = () =>
  [{ url: '/api/moderator/telegram/products/reasons' }] as const;

export type TelegramProductsModeratorFindRejectionReasonsQueryKey = ReturnType<
  typeof telegramProductsModeratorFindRejectionReasonsQueryKey
>;

export function telegramProductsModeratorFindRejectionReasonsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramProductsModeratorFindRejectionReasonsQueryKey();
  return queryOptions<
    TelegramProductsModeratorControllerFindRejectionReasonsQueryResponse,
    ResponseErrorConfig<TelegramProductsModeratorControllerFindRejectionReasons401>,
    TelegramProductsModeratorControllerFindRejectionReasonsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramProductsModeratorFindRejectionReasons(config);
    },
  });
}

/**
 * {@link /api/moderator/telegram/products/reasons}
 */
export function useTelegramProductsModeratorFindRejectionReasons<
  TData = TelegramProductsModeratorControllerFindRejectionReasonsQueryResponse,
  TQueryData = TelegramProductsModeratorControllerFindRejectionReasonsQueryResponse,
  TQueryKey extends QueryKey = TelegramProductsModeratorFindRejectionReasonsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramProductsModeratorControllerFindRejectionReasonsQueryResponse,
        ResponseErrorConfig<TelegramProductsModeratorControllerFindRejectionReasons401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramProductsModeratorFindRejectionReasonsQueryKey();

  const query = useQuery(
    {
      ...telegramProductsModeratorFindRejectionReasonsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramProductsModeratorControllerFindRejectionReasons401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
